import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import { youShallNotPass } from 'lib/helpers/youShallNotPass/youShallNotPass'

type Variant = 'default' | 'error'

interface RootProps {
  variant?: Variant
}

interface IconProps {
  variant?: Variant
}

export const Root = styled(Box, {
  shouldForwardProp: youShallNotPass('variant'),
})<RootProps>(({ theme, variant }) => ({
  flexGrow: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(3),
  color: theme.tokens.ThemeColorCommonOnSurfaceSecondary,
  height: '100%',
  ...(variant === 'error' && {
    color: theme.tokens.ThemeColorCommonError,
  }),
}))

export const Icon = styled('div', {
  shouldForwardProp: youShallNotPass('variant'),
})<IconProps>(({ theme, variant }) => ({
  color: theme.tokens.ThemeColorCommonOnSurfaceSecondary,
  marginBottom: theme.spacing(1.25),
  ...(variant === 'error' && {
    color: theme.tokens.ThemeColorCommonError,
  }),
}))

export const Action = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(2),
}))
